<template>
  <div class="page-2-wrapper">
    <img class="bg" :src="source('page-2-bg')" alt="" draggable="false">
    <video class="video-1" style="cursor: default" :src="source('page-2-video-1')" loop autoplay disablePictureInPicture muted="muted"/>
    <img class="more-services-btn" :src="source('more-services-btn')" @click="toPage('/products')" draggable="false" >
  </div>
</template>

<script>
import key from "@/api/key";

export default {
  name: 'page-2',
  components: { },
  data() {
    return {
    }
  },
  methods: {
    source(name) {
      return key.getByName(key.HOME, name).fileUrl
    },
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
.page-2-wrapper {
  position: relative;
  width: 100vw;
  height: 56.25vw;
  overflow: hidden;
  .video-1{
    width: 71vw;
    height: 12.5vw;
    position: absolute;
    left: 29vw;
    top: 30.25vw;
  }
  .more-services-btn{
    width: 36.56vw;
    height: 2.66vw;
    position: absolute;
    left: 29vw;
    top: 44.3vw;
    cursor: pointer;
  }
}
</style>
